/* Liton Ocell: progressive enhancements; shopping forms work without JavaScript. */
(() => {
  'use strict';
  const root = document.body.dataset.root.replace(/\/?$/, '/');
  const strings = JSON.parse(document.getElementById('ThemeStrings')?.textContent || '{}');
  const status = document.getElementById('StatusMessage');
  let statusTimer;
  const notify = message => { if (!status) return; clearTimeout(statusTimer); status.textContent = message; statusTimer = setTimeout(() => { status.textContent = ''; }, 5000); };
  const keys = { wishlist: 'liton-ocell:wishlist:v1', compare: 'liton-ocell:compare:v1', recent: 'liton-ocell:recent:v1' };
  const validHandle = h => typeof h === 'string' && /^[\p{L}\p{N}][\p{L}\p{N}-]{0,254}$/u.test(h);
  const readSaved = mode => { try { const values = JSON.parse(localStorage.getItem(keys[mode]) || '[]'); return Array.isArray(values) ? [...new Set(values.filter(validHandle))].slice(0, mode === 'compare' ? 3 : mode === 'recent' ? 4 : 40) : []; } catch { return []; } };
  function syncSaved() {
    for (const mode of ['wishlist', 'compare']) {
      const saved = readSaved(mode);
      const selector = mode === 'wishlist' ? '[data-save]' : '[data-compare]';
      document.querySelectorAll(selector).forEach(button => { button.hidden = false; button.setAttribute('aria-pressed', String(saved.includes(button.dataset.save || button.dataset.compare))); });
      document.querySelectorAll(mode === 'wishlist' ? '[data-saved-count]' : '[data-compare-count]').forEach(el => { el.textContent = saved.length || ''; el.hidden = !saved.length; });
    }
  }
  let savedRender = 0;
  async function renderSaved() {
    const page = document.querySelector('[data-saved-page], [data-recent-page]');
    if (!page) return;
    const generation = ++savedRender;
    const mode = page.hasAttribute('data-recent-page') ? 'recent' : page.dataset.savedPage;
    const list = readSaved(mode);
    const grid = page.querySelector('[data-saved-grid]');
    const empty = page.querySelector('[data-saved-empty]');
    grid.replaceChildren(); empty.hidden = list.length > 0;
    grid.setAttribute('aria-busy', 'true');
    let failures = 0;
    // Three concurrent reads, preserving selection order. No catalogue-wide fetch.
    for (let start = 0; start < list.length; start += 3) {
      const results = await Promise.all(list.slice(start, start + 3).map(async handle => {
        try {
          const response = await fetch(`${root}products/${encodeURIComponent(handle)}?sections=saved-product`, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('unavailable');
          const html = (await response.json())['saved-product'];
          if (!html) throw new Error('unavailable');
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const card = parsed.querySelector('.product-card');
          if (!card) throw new Error('unavailable');
          const column = document.createElement('div');
          column.append(card);
          const facts = parsed.querySelector('.comparison-facts');
          if (mode === 'compare' && facts) column.append(facts);
          return column;
        } catch {
          failures++;
          const column = document.createElement('div');
          const label = document.createElement('p'); label.textContent = `${handle}: ${strings.load_error}`;
          const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'text-link'; remove.textContent = strings.remove;
          if (mode !== 'recent') remove.dataset[mode === 'compare' ? 'compare' : 'save'] = handle; else remove.hidden = true;
          column.append(label, remove); return column;
        }
      }));
      if (generation !== savedRender) return;
      results.forEach(el => grid.append(el)); syncSaved();
    }
    grid.removeAttribute('aria-busy');
    if (failures) notify(strings.load_error);
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-save], [data-compare]');
    if (!button) return;
    const mode = button.hasAttribute('data-save') ? 'wishlist' : 'compare';
    const handle = button.dataset.save || button.dataset.compare;
    if (!validHandle(handle)) return;
    const saved = readSaved(mode); const exists = saved.includes(handle);
    if (!exists && saved.length >= (mode === 'compare' ? 3 : 40)) { notify(strings.compare_limit); return; }
    try { localStorage.setItem(keys[mode], JSON.stringify(exists ? saved.filter(h => h !== handle) : [...saved, handle])); }
    catch { notify(strings.storage_error); return; }
    syncSaved(); notify(exists ? strings.removed : strings.saved); renderSaved();
  });
  window.addEventListener('storage', event => { if (Object.values(keys).includes(event.key)) { syncSaved(); renderSaved(); } });
  document.querySelectorAll('[data-auto-submit]').forEach(select => select.addEventListener('change', () => {
    const destination = new URL(window.location.href);
    // These are the actual native filter values observed in both published locales.
    const flavourKey = 'filter.p.m.tea.flavour';
    const flavours = [['Floral', '꽃향'], ['Nutty', '고소한 향'], ['Roasted', '덖은 향'], ['Smoky', '훈연향']];
    const selectedFlavours = destination.searchParams.getAll(flavourKey);
    if (selectedFlavours.length) {
      destination.searchParams.delete(flavourKey);
      selectedFlavours.forEach(value => {
        const pair = flavours.find(values => values.includes(value));
        destination.searchParams.append(flavourKey, pair ? pair[select.value === 'ko' ? 1 : 0] : value);
      });
    }
    for (const [key, value] of [...destination.searchParams]) if (key.startsWith('filter.') && value === '') destination.searchParams.delete(key);
    const routes = JSON.parse(document.getElementById('TeaSearchRoutes')?.textContent || '{}');
    const exactRoute = routes[(destination.searchParams.get('q') || '').trim().toLowerCase()];
    if (exactRoute) {
      destination.pathname = exactRoute;
      for (const key of ['q', 'type', 'options[prefix]', 'page']) destination.searchParams.delete(key);
    }
    const hasFacets = exactRoute || [...destination.searchParams.keys()].some(key => key.startsWith('filter.'));
    if (hasFacets) {
      let returnTo = select.form.querySelector('[name="return_to"]');
      if (!returnTo) { returnTo = document.createElement('input'); returnTo.type = 'hidden'; returnTo.name = 'return_to'; select.form.append(returnTo); }
      returnTo.value = destination.pathname + destination.search;
    }
    select.form.requestSubmit();
  }));
  const typeSearch = document.querySelector('[data-predictive-search]');
  typeSearch?.addEventListener('submit', event => {
    const routes = JSON.parse(document.getElementById('TeaSearchRoutes')?.textContent || '{}');
    const target = routes[typeSearch.querySelector('[name="q"]').value.trim().toLowerCase()];
    if (target) { event.preventDefault(); window.location.assign(target); }
  });
  const menu = document.querySelector('[data-menu]');
  document.addEventListener('click', event => { if (menu?.open && !menu.contains(event.target)) menu.open = false; });
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && menu?.open) { menu.open = false; menu.querySelector('summary').focus(); } });
  const mobile = matchMedia('(max-width: 700px)');
  document.querySelectorAll('.mobile-filter').forEach(el => { el.open = !mobile.matches; });
  const variantSelect = document.querySelector('[data-variant-select]');
  variantSelect?.addEventListener('change', () => {
    const option = variantSelect.selectedOptions[0];
    const price = document.querySelector('[data-product-price]'); if (price) price.textContent = option.dataset.price;
    const compare = document.querySelector('[data-compare-price]'); if (compare) { compare.textContent = option.dataset.compareAt || ''; compare.hidden = !option.dataset.compareAt; }
    const add = document.querySelector('[data-add-button]'); if (add) { add.disabled = option.dataset.available !== 'true'; add.textContent = add.disabled ? strings.sold_out : strings.add; }
    const quantity = document.getElementById('Quantity');
    if (quantity) { quantity.min = option.dataset.min || '1'; quantity.step = option.dataset.step || '1'; quantity.value = quantity.min; if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max'); }
    const image = document.getElementById('ProductImage'); if (image && option.dataset.image) { image.src = option.dataset.image; image.removeAttribute('srcset'); }
    const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState(null, '', url);
  });
  document.querySelectorAll('[data-gallery-image]').forEach(link => link.addEventListener('click', event => { const image = document.getElementById('ProductImage'); if (!image) return; event.preventDefault(); image.src = link.dataset.galleryImage; image.removeAttribute('srcset'); image.alt = link.querySelector('img')?.alt || ''; }));
  function setupFilm(scope = document) {
    const video = scope.querySelector('[data-hero-video]');
    const control = scope.querySelector('[data-film-control]');
    if (!video || !control || video.dataset.initialized) return;
    video.dataset.initialized = 'true'; control.hidden = false;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const connection = navigator.connection;
    let loaded = false, userPaused = false, inView = true, autoStarted = false;
    const load = () => { if (loaded) return; video.querySelectorAll('[data-src]').forEach(source => { source.src = source.dataset.src; }); video.load(); loaded = true; };
    const update = () => { const playing = !video.paused; control.querySelector('[data-film-label]').textContent = playing ? strings.pause : strings.play; control.querySelector('[data-film-icon]').textContent = playing ? 'Ⅱ' : '▷'; control.setAttribute('aria-label', playing ? strings.pause : strings.play); };
    const play = async () => { load(); try { await video.play(); } catch { update(); } };
    video.addEventListener('playing', () => { video.classList.add('is-playing'); update(); });
    video.addEventListener('pause', update);
    video.addEventListener('error', () => { video.classList.remove('is-playing'); update(); });
    control.addEventListener('click', () => { if (video.paused) { userPaused = false; play(); } else { userPaused = true; video.pause(); } });
    const canAutoPlay = () => !mobile.matches && !reduced.matches && !connection?.saveData && !/2g/.test(connection?.effectiveType || '');
    const start = () => { if (canAutoPlay() && inView && !document.hidden && !userPaused) { autoStarted = true; play(); } };
    if (document.readyState === 'complete') start(); else window.addEventListener('load', start, { once: true });
    new IntersectionObserver(entries => { inView = entries[0].isIntersecting; if (!inView) video.pause(); else if (autoStarted && !userPaused && !document.hidden && canAutoPlay()) play(); }, { threshold: .1 }).observe(video);
    document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); else if (autoStarted && inView && !userPaused && canAutoPlay()) play(); });
    reduced.addEventListener('change', () => { if (reduced.matches) video.pause(); });
  }

  document.addEventListener('change', event => {
    if (!event.target.matches('[data-quick-variant]')) return;
    const select = event.target, option = select.selectedOptions[0];
    select.form.querySelector('[name="quantity"]').value = option.dataset.min || '1';
    select.form.querySelector('[type="submit"]').disabled = option.dataset.available !== 'true';
  });
  const topic = document.querySelector('[data-contact-topic]');
  const requestedTopic = new URLSearchParams(location.search).get('topic');
  if (topic && [...topic.options].some(o => o.value === requestedTopic)) topic.value = requestedTopic;
  const viewed = document.body.dataset.currentProductHandle;
  if (validHandle(viewed)) { try { localStorage.setItem(keys.recent, JSON.stringify([viewed, ...readSaved('recent').filter(h => h !== viewed)].slice(0, 4))); } catch {} }
  document.querySelector('[data-clear-recent]')?.addEventListener('click', () => { try { localStorage.removeItem(keys.recent); renderSaved(); } catch { notify(strings.storage_error); } });
  function predictiveSearch() {
    let features;
    try { features = JSON.parse(document.getElementById('shopify-features')?.textContent || '{}'); } catch { return; }
    const form = document.querySelector('[data-predictive-search]');
    if (!features.predictiveSearch || !form) return;
    const input = form.querySelector('[type="search"]'), results = form.querySelector('[data-predictive-results]');
    if (!results) return;
    let timer, controller, generation = 0, composing = false;
    results.id = 'SearchSuggestions'; results.setAttribute('role', 'region');
    results.setAttribute('aria-label', strings.suggestions || 'Suggested products');
    input.setAttribute('aria-controls', results.id); input.setAttribute('aria-expanded', 'false');
    const close = () => { results.hidden = true; input.setAttribute('aria-expanded', 'false'); };
    const update = () => {
      clearTimeout(timer); controller?.abort(); const current = ++generation; close();
      const term = input.value.trim(); if (composing || term.length < 2) return;
      timer = setTimeout(async () => {
        controller = new AbortController();
        try {
          const params = new URLSearchParams({q: term, section_id: 'predictive-search', 'resources[type]': 'product', 'resources[limit]': '6'});
          const response = await fetch(root + 'search/suggest?' + params, {signal: controller.signal, credentials: 'same-origin'});
          if (!response.ok) return;
          const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
          const list = parsed.querySelector('.predictive-list');
          if (current !== generation || !list?.querySelector('a')) return;
          results.replaceChildren(list); results.hidden = false; input.setAttribute('aria-expanded', 'true');
        } catch { if(current === generation) close(); }
      }, 180);
    };
    input.addEventListener('input', update);
    input.addEventListener('compositionstart', () => { composing = true; });
    input.addEventListener('compositionend', () => { composing = false; update(); });
    const dismiss = () => { clearTimeout(timer); controller?.abort(); generation++; close(); };
    form.addEventListener('keydown', event => { if (event.key === 'Escape') { dismiss(); input.focus(); } });
    document.addEventListener('click', event => { if (!form.contains(event.target)) dismiss(); });
  }
  syncSaved(); renderSaved(); setupFilm(); predictiveSearch();
  document.addEventListener('shopify:section:load', event => { syncSaved(); setupFilm(event.target); });
})();
